export enum SurveyEditorSidebarTabEnum {
  FieldSettings = 'FIELD_SETTINGS',
  SurveySettings = 'SURVEY_SETTINGS',
}
